// ============================================================================
// This file is PROJECT SPECIFIC
// ============================================================================

// Registration member types
const initMemberTypes = () => {
  const countrySelect = document.getElementById('user_country')
  const memberTypeSelect = document.getElementById('user_member_type_id')

  if (!countrySelect || !memberTypeSelect) return

  const isLocked = countrySelect.disabled
  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || '{}')

  const updateMemberTypeOptions = () => {
    const selectedCountryCode = countrySelect.value
    const desiredValue = memberTypeSelect.dataset.selectedValue || memberTypeSelect.value

    memberTypeSelect.innerHTML = '<option value="">Please Select</option>'

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true
      memberTypeSelect.value = ''
      memberTypeSelect.dataset.selectedValue = ''
      memberTypeSelect.dispatchEvent(new Event('change'))
      return
    }

    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData
      let shouldShow = false

      switch (country_rule) {
        case 'all_countries':
          shouldShow = true
          break
        case 'specific_countries':
          shouldShow = countries.includes(selectedCountryCode)
          break
        case 'exclude_countries':
          shouldShow = !countries.includes(selectedCountryCode)
          break
      }

      if (!shouldShow) return

      const option = document.createElement('option')
      option.value = id
      option.textContent = memberTypeName
      memberTypeSelect.appendChild(option)
    })

    if (
      Array.from(memberTypeSelect.options).some((option) => option.value === String(desiredValue))
    ) {
      memberTypeSelect.value = desiredValue
    } else {
      memberTypeSelect.value = ''
    }

    memberTypeSelect.disabled = isLocked || memberTypeSelect.options.length <= 1
    memberTypeSelect.dataset.selectedValue = ''
    memberTypeSelect.dispatchEvent(new Event('change'))
  }

  countrySelect.addEventListener('change', updateMemberTypeOptions)
  updateMemberTypeOptions()
}

const initMemberTypeUploadRequirement = () => {
  const memberTypeSelect = document.getElementById('user_member_type_id')
  const memberTypeUploadInput = document.getElementById('user_member_type_upload')
  const memberTypeUploadButton = document.querySelector('label[data-upload-button]')

  if (!memberTypeSelect || !memberTypeUploadInput) return

  const isEditMode = !!document.getElementById('current-membership')
  const exemptNames = JSON.parse(memberTypeUploadInput.dataset.exemptNames || '[]')

  if (memberTypeUploadButton) {
    memberTypeUploadButton.addEventListener('click', (e) => {
      if (memberTypeUploadButton.dataset.disabled === 'true') e.preventDefault()
    })
  }

  const updateUploadRequirement = () => {
    const selectedOption = memberTypeSelect.options[memberTypeSelect.selectedIndex]
    const selectedName = selectedOption?.text?.trim() || ''
    const applicable = selectedName.length > 0 && !exemptNames.includes(selectedName)

    memberTypeUploadInput.required = !isEditMode && applicable
    memberTypeUploadInput.disabled = !applicable

    if (memberTypeUploadButton) {
      memberTypeUploadButton.dataset.disabled = String(!applicable)
    }
  }

  memberTypeSelect.addEventListener('change', updateUploadRequirement)
  updateUploadRequirement()
}

// Initialize all custom functionality
const initRegistration = () => {
  initMemberTypes()
  initMemberTypeUploadRequirement()
}

export default initRegistration
